export default __webpack_public_path__ + "static/media/6、首页气泡果汁.3a3a1c75.jpg";